export const leadsApiUrl = {
  /* Lead */
  list: "/lead-management/leads",
};

export enum PLATFORM {
  tiktok = "tiktok",
}
